// extracted by mini-css-extract-plugin
export var actionButton = "_ge-0";
export var fileInput = "_ge-2";
export var paperclip = "_ge-1";